import ExcelJs from "exceljs";

const excelSheetExport = async (headers, list, title) => {
    const workbook = new ExcelJs.Workbook();
    const worksheet = workbook.addWorksheet(title || "My Sheet");


    const dataToImport = headers && headers.map((col) => {
        return {
            header: col.headerName,
            key: col.key,
            // width: col.headerWidhth
            width: col.headerWidhth || Math.max((col.headerName.length * 2) + 2, 10)
        }
    })

    worksheet.columns = dataToImport;
    worksheet.addRows(list);
    const headerRow = worksheet.getRow(1);
    headerRow.eachCell((cell) => {
        // Set font style
        cell.font = {
            name: "TimesNewRoman",
            bold: true,
            size: 14,
            color: { argb: "FFFFFF" },
        };

        // Set alignment
        cell.alignment = { wrapText: true, vertical: "middle" };

        // Set background color
        cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "9AA6B2" },
        };
    });

    // Create a downloadable file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: "application/octet-stream" });
    saveAs(blob, `${title}.xlsx`);
}

export { excelSheetExport }